import React, { FC } from 'react';
import { ReactComponent as HistoryIcon } from 'app/assets/images/redesign/history.svg';
import { ReactComponent as SuccessIcon } from 'app/assets/images/redesign/success.svg';
import { ReactComponent as CancelledIcon } from 'app/assets/images/redesign/cancelled.svg';
import { ERequestStatus, ERequestStatusLabel } from 'entities/Request/Request.enum';
import { getRequestStatus } from 'entities/Request/Request.helper';

interface IComponentProps {
  status: string;
}

export const RequestStatus: FC<IComponentProps> = ({ status }) => {
  const { isCreatedRequest, isProcessingRequest, isDeliveredRequest, isCancelledRequest } = getRequestStatus(status);

  const getStatusIcon = () => {
    switch (true) {
      case isCreatedRequest: {
        return <HistoryIcon className="icon-history-pale-yellow" />;
      }
      case isProcessingRequest: {
        return <SuccessIcon />;
      }
      case isDeliveredRequest: {
        return <SuccessIcon className="icon-success-dark-grey" />;
      }
      case isCancelledRequest: {
        return <CancelledIcon className="icon-cancelled-fill-red" />;
      }
      default: {
        return false;
      }
    }
  };

  return (
    <div className={`request-status ${status}`}>
      {getStatusIcon()}

      <span className="text-tag-accent request-status__label">{ERequestStatusLabel[status as ERequestStatus]}</span>
    </div>
  );
};
